import dayjs from 'dayjs';
import { Notification } from 'ksnm-common-ui/lib/Notification';
import { date, object, string } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';

const validateSchema = object().shape({
  ctrlVersCode: textValidator({ fieldName: 'ctrlVersCode' }),
  ctrlCode: textValidator({ fieldName: 'ctrlCode' }),
  versionNum: textValidator({ fieldName: 'versionNum' }),
  dateFrom: date().nullable().required(),
  dateTo: date()
    .nullable()
    .test('dateTo', 'Дата окончания должна быть позже даты начала', (value, { parent: { dateFrom } }) => {
      if (!dateFrom) return true;

      return !dayjs(new Date(`${value}`)).isBefore(dayjs(new Date(dateFrom)));
    }),
  ctrlVersExt: textValidator({ fieldName: 'ctrlVersExt' }),
  ctrlVersDesc: textValidator({ fieldName: 'ctrlVersDesc' }),
  textSuccess: string().test('textSuccess', 'Описание статусов должно быть заполнено', (value) => {
    if (!value) {
      Notification({
        message: 'Описание статусов должно быть заполнено',
      });

      return false;
    }

    return true;
  }),
});

export const validate = createValidator(validateSchema);
